<!--<div class="fs-2 with-close" mat-dialog-title>-->
<!--    Partager la liste-->
<!--    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>-->
<!--</div>-->
<div mat-dialog-content class="partner mt-2">
    <img src="{{ partner.logo }}" alt="{{ partner.title }}"/>
    <h3>{{ partner.title }}</h3>
    <p class="categorie {{partner.categorie.replace(' ', '') | lowercase }}">{{ partner.categorie }}</p>
    <b class="subtitle mt-4">{{ partner.sub_title }}</b>
    <p [innerHTML]="partner.description_full | nl2br"></p>
    <b class="profit mb-2 mt-4">{{ partner.offers }}</b>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Retour
    </button>
    <a href="{{ partner.link }}" class="btn btn-primary">
        Profiter de l’offre
    </a>
</div>
